var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ff462d",
  d: "M15 0C6.716 0 0 6.716 0 15s6.716 15 15 15 15-6.716 15-15S23.284 0 15 0m0 2c7.18 0 13 5.82 13 13s-5.82 13-13 13S2 22.18 2 15 7.82 2 15 2m-4.243 7.343L15 13.585l4.244-4.242a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 0 1.414L16.414 15l4.243 4.244a1 1 0 1 1-1.414 1.414l-4.244-4.243-4.242 4.243a1 1 0 0 1-1.32.083l-.094-.083a1 1 0 0 1 0-1.414l4.242-4.244-4.242-4.242a1 1 0 1 1 1.414-1.414"
})));
export default SvgError;